import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "stars"
const StarsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.137 18.125C10.432 17.703 11.07 17.703 11.364 18.125L11.42 18.223 11.562 18.503 11.841 18.641C12.391 18.919 12.391 19.707 11.84 19.984L11.56 20.124 11.421 20.402C11.146 20.955 10.357 20.954 10.08 20.403L9.94 20.123 9.66 19.983C9.11 19.708 9.11 18.92 9.66 18.643L9.94 18.502 10.08 18.223zM16.286 11.508C16.733 10.756 17.853 10.781 18.256 11.583L18.808 12.69 19.917 13.245C20.744 13.659 20.744 14.84 19.917 15.255L18.809 15.81 18.255 16.916C17.84 17.744 16.66 17.744 16.245 16.916L15.69 15.81 14.584 15.255C13.756 14.84 13.756 13.66 14.584 13.245L15.69 12.69 16.245 11.583zM16.976 13.473C16.865 13.69 16.69 13.866 16.472 13.975L15.924 14.25 16.474 14.525C16.663 14.62 16.821 14.767 16.93 14.948L16.975 15.027 17.251 15.575 17.525 15.027 17.569 14.947C17.679 14.768 17.837 14.62 18.027 14.526L18.575 14.25 18.027 13.975C17.81 13.866 17.634 13.69 17.525 13.473L17.251 12.924zM8.035 3.258C8.483 2.506 9.604 2.531 10.006 3.333L11.31 5.94 13.917 7.244C14.745 7.66 14.745 8.84 13.917 9.255L11.31 10.561 10.005 13.166C9.591 13.994 8.41 13.994 7.995 13.166L6.689 10.561 4.084 9.255C3.256 8.84 3.256 7.66 4.084 7.245L6.689 5.938 7.995 3.333zM7.974 6.722C7.865 6.939 7.69 7.115 7.472 7.224L5.424 8.25 7.472 9.276C7.662 9.37 7.822 9.517 7.932 9.698L7.973 9.778 9.001 11.825 10.026 9.778 10.07 9.698C10.18 9.518 10.338 9.37 10.528 9.276L12.575 8.25 10.528 7.224C10.31 7.115 10.135 6.939 10.026 6.722L9.001 4.674z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default StarsIcon
